import { Table } from '@tanstack/react-table';

import { EdgeUpdateListItemResponse } from '@/react/portainer/environments/update-schedules/queries/list';

import { ColumnVisibilityMenu } from '@@/datatables/ColumnVisibilityMenu';
import { TableSettingsMenu } from '@@/datatables';
import { TableSettingsMenuAutoRefresh } from '@@/datatables/TableSettingsMenuAutoRefresh';
import { TableSettingsMenuCheckbox } from '@@/datatables/TableSettingsMenuCheckbox';

import { TableSettings } from './store';

export function TableSettingsMenus({
  tableInstance,
  tableState,
}: {
  tableInstance: Table<EdgeUpdateListItemResponse>;
  tableState: TableSettings;
}) {
  return (
    <>
      <ColumnVisibilityMenu<EdgeUpdateListItemResponse>
        table={tableInstance}
        onChange={(hiddenColumns) => {
          tableState.setHiddenColumns(hiddenColumns);
        }}
        value={tableState.hiddenColumns}
      />
      <TableSettingsMenu>
        <TableSettingsMenuCheckbox
          id="settings-menu-multi-select"
          label="Multi-select"
          data-cy="multi-select"
          value={tableState.multiSelectEnabled}
          onChange={(value) => {
            tableState.setMultiSelectEnabled(value);
          }}
        />
        <TableSettingsMenuAutoRefresh
          value={tableState.autoRefreshRateMS}
          onChange={(value) => tableState.setAutoRefreshRate(value)}
        />
      </TableSettingsMenu>
    </>
  );
}
